import { MNOSearchFilter } from 'src/common/components/Filters/Inputs/mnos/MNOSearchFilter';
import {
  rsimMnoNamesFilterAtom,
  rsimMobileNetworkOperatorFilterAtom,
  rsimMobileNetworkOperatorIdFilterAtom,
} from 'atoms/filters/rsim-products.ts';
import { rsimMnoHintsAtom } from 'atoms/hints/rsim-products.ts';

export const RSimMnoSearchInput = () => {
  return (
    <MNOSearchFilter
      mnoFilterAtom={rsimMobileNetworkOperatorFilterAtom}
      mnoNamesFilterAtom={rsimMnoNamesFilterAtom}
      mnoHintsAtom={rsimMnoHintsAtom}
      mnoIdFilterAtom={rsimMobileNetworkOperatorIdFilterAtom}
    />
  );
};
